"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=resource.js.map